export const load = () => ({
	title: 'Interior vs Exterior Storm Windows',
	showTitle: true,
});
